export default __webpack_public_path__ + "static/media/hero.7a84fadd.png";